import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import "dayjs/locale/ko";

dayjs.extend(relativeTime);

// Initialize locale based on stored language preference
const initializeLocale = () => {
  const storedLang =
    typeof window !== "undefined" ? localStorage.getItem("lang") : "en";
  if (storedLang === "kr") {
    dayjs.locale("ko");
  } else {
    dayjs.locale("en");
  }
};

// Initialize on module load
initializeLocale();

// Listen for language changes
if (typeof window !== "undefined") {
  window.addEventListener("storage", (e) => {
    if (e.key === "lang") {
      initializeLocale();
    }
  });
}

export class DateNTime {
  static formatUTC(
    utcString: string,
    format: string = "YYYY-MM-DD HH:mm",
  ): string {
    // Ensure locale is set before formatting
    initializeLocale();
    return dayjs(utcString).format(format);
  }

  static formatRelative(dateString: string): string {
    // Ensure locale is set before formatting
    initializeLocale();
    return dayjs(dateString).fromNow();
  }

  static setLocale(locale: "en" | "kr") {
    if (locale === "kr") {
      dayjs.locale("ko");
    } else {
      dayjs.locale("en");
    }
  }
}
